import { fetchPageData } from "../utils/fetch";

export const getResources = async (endpoint) => {
  const method = "GET";
  const err = `Failed to fetch ${endpoint}.`;
  const fetchedData = await fetchPageData(endpoint, method, err);
  return fetchedData;
};
export const updateResource = async (endpoint, token, itemId, resourceData) => {
  resourceData.forEach((value, key) => {
    console.log(key, value);
  });

  const newEndpoint = itemId
    ? `${endpoint.slice(0, -1)}/${itemId}`
    : `${endpoint.slice(0, -1)}`;
  const err = itemId
    ? `Editing ${endpoint.slice(0, -1)} failed.`
    : `Creating ${endpoint.slice(0, -1)} failed.`;
  const method = itemId ? "PUT" : "POST";

  const fetchedData = await fetchPageData(
    newEndpoint,
    method,
    err,
    token,
    resourceData
  );
  return fetchedData;
};

export const deleteResource = async (endpoint, token, sdgsProjectId) => {
  const newEndpoint = `${endpoint.slice(0, -1)}/${sdgsProjectId}`;
  const method = "DELETE";
  const err = "Deleting sdgsProject failed.";
  const fetchedData = await fetchPageData(newEndpoint, method, err, token);
  return fetchedData;
};
